export default __webpack_public_path__ + "static/media/poster-jaktim-grandprix.7c00056f.png";